import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'
import { routes } from './app.routes'
import { provideTranslateService, RootTranslateServiceConfig } from '@ngx-translate/core'
import { provideHttpClient, withFetch } from '@angular/common/http'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { ToastService } from '@siemens/ix-angular/standalone'
import { provideNuMonacoEditorConfig } from '@ng-util/monaco-editor'
import { AuthService, COOKIE_AUTH_CONFIG } from './core/auth/auth.contract'
import { AuthCookieService } from './core/auth/auth-cookie.service'
import { APP_CONFIG } from 'environments/environment.model'
import { authConfig as cookieAuthConfig } from 'environments/auth.config'

const cookieConfig = {
  url: '/api/users',
  auth: { mode: 'cookie' as const, cookie: cookieAuthConfig },
}

export const provideTranslation = (): RootTranslateServiceConfig => ({
  fallbackLang: 'en',
  loader: provideTranslateHttpLoader({
    prefix: './assets/i18n/',
    suffix: '.json',
  }),
})

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_CONFIG, useValue: cookieConfig },
    { provide: COOKIE_AUTH_CONFIG, useValue: cookieAuthConfig },
    { provide: AuthService, useClass: AuthCookieService },
    provideZonelessChangeDetection(),
    ToastService,
    provideNuMonacoEditorConfig({
      defaultOptions: {
        automaticLayout: true,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        wordWrap: 'on',
      },
    }),
    provideHttpClient(withFetch()),
    provideRouter(routes, withComponentInputBinding()),
    provideTranslateService(provideTranslation()),
  ],
}
